import React from "react";
import { Box, Typography } from "@mui/material";

interface EmptyStateMessageProps {
  message: string;
}

export const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
  message,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 200,
        color: "text.secondary",
      }}
    >
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
};
